import React from 'react'
import './Hero.css'
import Header from '../Header/Header'
import hero_image from '../../assets/hero_image.png'
import hero_image_back from '../../assets/hero_image_back.png'
import Heart from '../../assets/heart.png'
import Calories from '../../assets/calories.png' 
import {motion} from 'framer-motion'
import NumberCounter from 'number-counter'
const Hero = () => {
    const transition = {type: 'spring', duration : 3}
    const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <div className="hero" id = "home">
        <div className="blur hero-blur"></div>
        <div className="left-h">
            <Header/>
            {/* The Best ad */}
            <div className="the-best-ad">
                <motion.div
                initial =  {{left: mobile ? '165px' : '238px'}}
                whileInView={{left: '8px'}}
                transition = {{...transition, type: 'tween'}}
                ></motion.div>
                <span>The best fitness club in the town</span>
            </div>
            {/* Hero Header */}
            <div className="hero-text">
                <div>
                    <span className='stroke-text'>Shape </span>
                    <span>Your</span>
                </div>
                <div><span>Ideal Body</span></div>
                {/* info div */}
                <div>
                    <span>In here we will help you to shape and build your ideal body and 
                        live up your life to fullest 
                    </span>
                </div>
            </div>
            {/* figures */}
            <div className="figures">
                <div>
                    <span>
                        <NumberCounter end={140} start= {100} preFix = {"+"} delay = {4}/>
                    </span>
                    <span>expert coaches</span>
                </div>
                <div>
                    <span>
                        <NumberCounter end={978} start= {900} preFix = {"+"} delay = {4}/>
                    </span>
                    <span>Members joined</span>
                </div>
                <div>
                    <span>
                        <NumberCounter end={40} start= {20} preFix = {"+"} delay = {4}/>
                    </span>
                    <span>fitness programs</span>
                </div>
            </div>

            {/* hero buttons */}
            <div className='hero-buttons'>
            <buttons className="btn">Get Started</buttons>
            <buttons className="btn">Learn More</buttons>
            </div>
        </div>
        <div className="right-h">
            <button className='btn'>Join Now</button>

            <motion.div 
            transition={transition}
            initial = {{right: "-1rem"}}
            whileInView = {{right: "4rem"}}
            className="heart-rate">
                <img src={Heart} alt=""/>
                <span>Heart Rate</span>
                <span>116 bpm</span>
            </motion.div>
            {/* Hero images */}
            <img src={hero_image} alt="" className='hero-image'/>
            <motion.img 
            transition={transition}
            initial = {{right: "12rem"}}
            whileInView = {{right: "20rem"}}
            src={hero_image_back} alt="" className='hero-image-back'/>
            {/* calories */}
            <motion.div 
            transition={transition}
            initial = {{right: "37rem"}}
            whileInView = {{right: "28rem"}}
            className="calories">
                <img src={Calories} alt="" />
                <div>
                    <span>Calories Burnt</span>
                    <span>229 kcal</span>
                </div>
            </motion.div>
        </div>
    </div>
  )
}

export default Hero
